export let PageType = /*#__PURE__*/function (PageType) {
  PageType["Product"] = "Product";
  PageType["Category"] = "Category";
  PageType["Page"] = "Page";
  return PageType;
}({});

// TODO: consume it from stores API
export let ProductPageLayoutType = /*#__PURE__*/function (ProductPageLayoutType) {
  ProductPageLayoutType[ProductPageLayoutType["EmptyState"] = 0] = "EmptyState";
  ProductPageLayoutType[ProductPageLayoutType["Classic"] = 1] = "Classic";
  ProductPageLayoutType[ProductPageLayoutType["QuickView"] = 2] = "QuickView";
  ProductPageLayoutType[ProductPageLayoutType["Sleek"] = 4] = "Sleek";
  ProductPageLayoutType[ProductPageLayoutType["Stunning"] = 5] = "Stunning";
  ProductPageLayoutType[ProductPageLayoutType["Spotlight"] = 6] = "Spotlight";
  ProductPageLayoutType[ProductPageLayoutType["Simple"] = 7] = "Simple";
  ProductPageLayoutType[ProductPageLayoutType["Responsive"] = 8] = "Responsive";
  return ProductPageLayoutType;
}({});

// TODO: consume it from stores API
export let CategoryPageLayoutType = /*#__PURE__*/function (CategoryPageLayoutType) {
  CategoryPageLayoutType[CategoryPageLayoutType["Inline"] = 0] = "Inline";
  CategoryPageLayoutType[CategoryPageLayoutType["Top"] = 1] = "Top";
  return CategoryPageLayoutType;
}({});
//# sourceMappingURL=types.js.map